import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "results", "entityOpponentId", "opponentTeamId" ]
  static values = { url: String }

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    document.addEventListener("click", this.handleDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  search() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    this.clearSelectionIds()

    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.searchTimeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  fetchResults(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)

    fetch(url.toString(), {
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then((response) => response.json())
      .then((data) => this.renderResults(data))
      .catch(() => this.hideResults())
  }

  renderResults(data) {
    const opponents = data.opponents || []
    const schools = data.schools || []

    if (opponents.length === 0 && schools.length === 0) {
      this.hideResults()
      return
    }

    let html = ""

    if (opponents.length > 0) {
      html += `<li class="dropdown-header color-fanword-text" style='margin-top: 0px !important;'>Your opponents</li>`
      opponents.forEach((opponent) => {
        html += this.resultItemHtml({
          label: opponent.name,
          type: "opponent",
          opponentId: opponent.id,
          teamId: opponent.team_id || "",
          name: opponent.name
        })
      })
    }

    if (schools.length > 0) {
      html += `<li class="dropdown-header color-fanword-text" style='margin-top: 0px !important;'>Schools</li>`
      schools.forEach((school) => {
        const subtitle = school.university_name && school.university_name !== school.title ? ` (${school.university_name})` : ""
        html += this.resultItemHtml({
          label: `${school.title}${subtitle}`,
          type: "school",
          opponentId: "",
          teamId: school.id,
          name: school.title
        })
      })
    }

    this.resultsTarget.innerHTML = html
    this.resultsTarget.classList.add("show")
  }

  resultItemHtml({ label, type, opponentId, teamId, name }) {
    return `
      <li>
        <button type="button" class="dropdown-item" data-action="click->opponent-autocomplete#select"
          data-type="${type}"
          data-opponent-id="${opponentId}"
          data-team-id="${teamId}"
          data-name="${this.escapeAttribute(name)}">
          ${this.escapeHtml(label)}
        </button>
      </li>
    `
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget

    this.inputTarget.value = button.dataset.name
    this.entityOpponentIdTarget.value = button.dataset.opponentId || ""
    this.opponentTeamIdTarget.value = button.dataset.teamId || ""
    this.hideResults()
  }

  clearSelectionIds() {
    this.entityOpponentIdTarget.value = ""
    this.opponentTeamIdTarget.value = ""
  }

  hideResults() {
    this.resultsTarget.classList.remove("show")
    this.resultsTarget.innerHTML = ""
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
  }

  escapeAttribute(value) {
    return this.escapeHtml(value).replace(/'/g, "&#39;")
  }
}
